import { useCallback, useEffect, useState } from 'react';
import user from 'stores/user';
import { useEthersProvider } from './useEthersProvider';
import { getContract } from 'utils';
import { Contract } from 'ethers';

import CapsuleABI from 'contracts/capsule.json';
import contracts from 'stores/contracts';

import { useAccount, useChainId } from 'wagmi';
import { DefaultChainId } from 'constant';

export function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
    const chainId = useChainId();
    const { address: account } = useAccount();
    const provider = useEthersProvider({
        chainId: chainId || DefaultChainId,
        account,
    });

    const [contract, setContract] = useState<Contract | null>(null);

    async function init() {
        if (!address || !ABI || !provider) {
            console.log('Missing required parameters for contract initialization:', {
                address,
                hasABI: !!ABI,
                hasProvider: !!provider,
            });
            return null;
        }
        try {
            console.log('Initializing contract with address:', address);
            const contract = await getContract(
                address,
                ABI,
                provider as any,
                withSignerIfPossible && account ? account : undefined,
            );
            console.log('Contract initialized successfully');
            setContract(contract);
        } catch (error) {
            console.error('Failed to get contract', error);
            console.error('Contract address:', address);
            setContract(null);
        }
    }

    useEffect(() => {
        init();
    }, [address, ABI, provider, withSignerIfPossible, account]);

    return contract;
}

export function useGetContract() {
    const chainId = useChainId();
    const { address: account } = useAccount();
    const provider = useEthersProvider({
        chainId: chainId || DefaultChainId,
        account,
    });

    return useCallback(
        async (address: string, ABI: any) => {
            return await getContract(address, ABI, provider as any, account ? account : undefined);
        },
        [provider, account],
    );
}
export function useGetContractByChainId() {
    const { address: account } = user;
    const chainId = useChainId();
    const { address } = useAccount();
    const provider = useEthersProvider({
        account: address,
        chainId: chainId || DefaultChainId,
    });
    return useCallback(
        async (address: string, ABI: any) => {
            if (!address || !ABI || !provider) return null;
            return await getContract(address, ABI, provider as any, account);
        },
        [account, provider],
    );
}

export function useCapsule() {
    return useContract(contracts?.capsule?.address, CapsuleABI);
}
